export const program = {
  noEligibleUsers: 'Sorry! There are no eligible members for this program.',
  title: {
    selectToStart: 'Select to get started',
    selectUser: 'Please select a member to access their resources.',
    activeMembers: 'Active members',
  },
  subtitle: {
    accessProgram: 'Access program resources and manage subscription',
  },
  action: {
    goBack: 'Go Back Home',
  },
  error: {
    failedToLoadProviders: 'Failed to load providers',
    failedToLoadPatients: 'Failed to load patients',
    failedToScheduleConsultation: 'Failed to schedule consultation',
    failedToBookAppointment: 'Failed to book appointment',
    failedToGetProgram: 'Failed to get program',
    failedToProcessFlow: 'Failed to process flow',
    filedToRemoveReservation: 'Failed to remove reservation',
    failedToSheduleAppointment: 'Failed to schedule appointment',
  },
};
